import { DateCalendar } from '@mui/x-date-pickers/DateCalendar';
import dayjs from 'dayjs';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDuplicateActivityToDateMutation } from '../../../../hooks/mutations/useActivityMutation';
import ModalBody, { ModalProps } from '../../ModalBody';

interface DuplicateActivityModalProps extends ModalProps {
    activityId: string;
    initialDate?: Date;
    name?: string;
}

const DuplicateActivityModal: React.FC<DuplicateActivityModalProps> = ({ activityId, initialDate = new Date(), open, handleClose, name }) => {
    const { t } = useTranslation();
    const [selectedDate, setSelectedDate] = useState<Date>(initialDate);

    const mutation = useDuplicateActivityToDateMutation({
        onSuccess: () => {
            handleClose();
        },
    });

    const handleOk = () => {
        mutation.mutate({
            activityId,
            body: { targetDate: selectedDate.toISOString() },
        });
    };

    return (
        <ModalBody
            title={t('activity')}
            subtitle={t('duplicate')}
            description={name}
            open={open}
            handleClose={handleClose}
            onSubmit={handleOk}
            submitLoading={mutation.isLoading}
        >
            <div className="fx-c">
                <DateCalendar
                    onChange={(value) => {
                        if (value) setSelectedDate(new Date(value.toISOString()));
                    }}
                    value={dayjs(selectedDate)}
                    displayWeekNumber
                />
            </div>
        </ModalBody>
    );
};

export default DuplicateActivityModal;
